import axiosInstance from '../utils/axiosConfig'; 
import { useState, useEffect } from 'react';
import '../assets/styles/auth.css';
import RegistrationField from '../components/RegistrationField';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await axiosInstance.post('/auth/login/', {
        email,
        password,
      });

      localStorage.setItem('Token', response.data.token);
      localStorage.setItem('Email', email);
      setSuccess('Login successful!');

      setTimeout(() => {
        navigate('/project/view');
      }, 1500);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Invalid email or password');
    }
  };

  useEffect(() => {
  document.title = "DCode | Login";
}, []);

  return (
    <>

      <Navbar />
      <section id="login">
        <div className="login-container" data-aos="flip-left">
          <h2 className="form-title">Log in</h2>
          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}
          <form action="#" className="login-form" onSubmit={handleLogin}>
            <RegistrationField
              type="email"
              placeholder="Email address"
              icon="mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <RegistrationField
              type="password"
              placeholder="Password"
              icon="lock"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <a href="/forgot-password" className="forgot-password-link">
              Forgot password?
            </a>
            <button type="submit" className="login-button">
              Log In
            </button>
          </form>
          <p className="signup-prompt">
            Don&apos;t have an account?{' '}
            <a href="/signup" className="signup-link">
              Sign up
            </a>
          </p>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Login;